import contentRequest from '~/src/api/requests/contentRequest';
import { isAxiosError } from '~/src/helpers/whoseError';
import { captureException } from '@sentry/node';

// Коды страниц на которых должны выводится вопросы
export enum EPlaces {
    Main = 3,
    Question = 13,
    Search = 23,
}

interface ICategoriesParams {
    places?: Array<EPlaces>,
}

interface ICategory {
    category_id: number,
    category_name: string,
}
export interface ICategoryResp {
    ok: boolean,
    items: ICategory[],
    error: string | undefined | null,
}

/**
 * Список категорий
 */
export async function getFaqCategories(params: ICategoriesParams): Promise<ICategoryResp> {
    try {
        const resp = await contentRequest.getWithCache('/v2/faq-categories', { params });
        const { items } = resp.data;
        return ({
            ok: true,
            items,
            error: null,
        });
    } catch (err) {
        if (isAxiosError(err)) {
            return ({
                ok: false,
                items: [],
                error: err.response?.statusText,
            });
        }

        captureException(err);

        return ({
            ok: false,
            items: [],
            error: 'Внутренняя ошибка сервера',
        });
    }
}

// ------------------------------------------------------------------------- //
export enum EExpand {
    Categories = 'categories',
    Places = 'places',
    FaqType = 'faqType',
    FaqChild = 'faqChild',
    FaqParent = 'faqParent',
}

export enum EFields {
    Answer = 'answer',
    Question = 'question',
    FaqId = 'faq_id',
    Updated = 'updated',
}

interface IArticlesParams {
    categories?: Array<number>,
    places?: Array<EPlaces>,
    find?: string,
    fields?: Array<EFields>,
    expand?: Array<EExpand>,
}

interface IFaqParams {
    categories?: Array<number>,
    places?: Array<EPlaces>,
    find?: string,
    fields?: string,
    expand?: string,
}

export interface IFaqArticle {
    faq_id?: number,
    question?: string,
    answer?: string,
    [key:string]: any,
}
export interface IArticlesResp {
    ok: boolean,
    items: IFaqArticle[],
    error: string | undefined | null,
}

function convertParams(incParams?:IArticlesParams):IFaqParams {
    const params:IFaqParams = {};
    if (!incParams) {
 return params;
}

    if (incParams.fields) {
        params.fields = incParams.fields.join(',');
    }
    if (incParams.expand) {
        params.expand = incParams.expand.join(',');
    }
    if (incParams.categories) {
        params.categories = incParams.categories;
    }
    if (incParams.places) {
        params.places = incParams.places;
    }
    if (incParams.find) {
        params.find = incParams.find;
    }

    return params;
}

/**
 * Список вопросов
 * https://gitlab.ertelecom.ru/web/api-content#%D0%B2%D0%BE%D0%BF%D1%80%D0%BE%D1%81%D1%8B-%D0%B8-%D0%BE%D1%82%D0%B2%D0%B5%D1%82%D1%8B - описание
 * /perm/v2/faqs?fields=faq_id,expand=categories&Cquestion&places[]=23&categories[]=31&find=счет - пример
 * categories - массив id - категорий
 * places - массив id - мест
 * find - строка поиска (по заголовку и содержимому статьи)
 * fields - массив полей в ответе, если пусто - все поля
 * expand - дополнительные поля ответа
 * @return {Promise}
 */
export async function getFaqArticles(cityDomain: string, incParams?:IArticlesParams):Promise<IArticlesResp> {
    const params = convertParams(incParams);

    try {
        const resp = await contentRequest.getWithCache(`/${cityDomain}/v2/faqs`, { params });
        const { data } = resp;
        return ({
            ok: true,
            items: data,
            error: null,
        });
    } catch (err) {
        if (isAxiosError(err)) {
            return ({
                ok: false,
                items: [],
                error: err.response?.statusText,
            });
        }

        captureException(err);

        return ({
            ok: false,
            items: [],
            error: 'Внутренняя ошибка сервера',
        });
    }
}

// ------------------------------------------------------------------------- //
// Вопросы и ответы, получение записи по id
interface IFaqArticleParams {
    expand?: Array<EExpand>,
}

export interface IArticleResp {
    ok: boolean,
    data: IFaqArticle | null,
    error: string | undefined | null,
}

/**
 * Вопросы и ответы, получение записи по id
 * @return {Promise}
 */
export async function getFaqArticle(cityDomain: string, articleId: number, incParams?:IFaqArticleParams):Promise<IArticleResp> {
    const params = convertParams(incParams);

    try {
        const resp = await contentRequest.getWithCache(`/${cityDomain}/v2/faqs/${articleId}`, { params });
        const { data } = resp;
        return ({
            ok: true,
            data,
            error: null,
        });
    } catch (err) {
        if (isAxiosError(err)) {
            return ({
                ok: false,
                data: null,
                error: err.response?.statusText,
            });
        }

        captureException(err);

        return ({
            ok: false,
            data: null,
            error: 'Внутренняя ошибка сервера',
        });
    }
}
